import { default as WJElement } from '../wje-element/element.js';
import CardTitle from './card-title.element.js';

// export * from "./card-title.element.js";
export default CardTitle;

WJElement.define('wje-card-title', CardTitle);
